import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { filterByCategory, getCategoryConfig } from "../../data/registry";
import AllResultsCard from "./allResultsCard";
import SearchLayout from "../layout/searchLayout";

function CategoryResults() {
  const { category } = useParams<{ category: string }>();
  const config = category ? getCategoryConfig(category) : undefined;

  if (!config || !category) return <Navigate to="/notfound" replace />;

  const items = filterByCategory(category);

  return (
    <SearchLayout>
      <p className="result-count">
        {config.label} {items.length} results ({config.resultTime}s seconds)
      </p>
      <AllResultsCard results={items} />
    </SearchLayout>
  );
}

export default CategoryResults;
